import { compact } from 'lodash-es';

import { JobTitle } from '@pflegia/data-access';
import { JobTitleEnum } from '@pflegia/types/api/job-title/job-titles.enum';
import { assertIsDefined } from '@pflegia/util/common/type-guards';

export const findDowngradedJobTitles = (downgradedJobTitles: JobTitleEnum[] | null, jobTitles: JobTitle[], isPraxia: boolean) => {
  if (!downgradedJobTitles?.length) return null;

  const newJobTitles = compact(
    downgradedJobTitles.map(downgradedJt => {
      const newJobTitle = jobTitles.find(jobTitle => jobTitle.title === downgradedJt);
      /**
       * Non-Praxia Job Position could end up in Praxia MP funnel
       * Sometimes downgrades would not be always Praxia Job Titles (e.g Nursing Area do not include MedicalStaff )
       * Hence the downgrade would eventually fail.
       */
      if (isPraxia && !newJobTitle) return null;
      assertIsDefined(newJobTitle, 'Downgraded job title');
      return newJobTitle;
    }),
  );

  return newJobTitles?.length ? newJobTitles : null;
};
